export default __webpack_public_path__ + "static/media/mailchimp.8246cbbb.svg";